exports = module.exports = require("../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-rewriter.js?id=data-v-bd26cd6c!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/App.vue
// module id = 13
// module chunks = 0